import React from 'react';
import { ProgressBreadcrumbListTheme } from './ProgressBreadcrumbList';

export const ProgressBreadcrumb: React.FC<{
    id: string;
    number: number;
    children: any;
    currentNumber?: number; //should be handled through the ProgressBreadcrumbList and passed through
    hasProgressed?: boolean; //should be handled through the ProgressBreadcrumbList activeCrumbNumber and passed through
    handleClick?: React.MouseEventHandler;
    enabled?: boolean;
    theme?: ProgressBreadcrumbListTheme;
}> = ({
    id,
    number,
    children,
    currentNumber = 0,
    hasProgressed = false,
    handleClick,
    enabled = true,
    theme = ProgressBreadcrumbListTheme.Blue,
}) => {
    const setStyle = {
        cursor: `${enabled ? 'pointer' : 'arrow'}`,
    };

    const performClick = (e: React.MouseEvent) => {
        if (enabled && handleClick) {
            handleClick(e);
        }
    };

    const status = () => {
        if (number == currentNumber) {
            return 'current';
        } else if (hasProgressed) {
            return 'completed';
        } else {
            return;
        }
    };

    return (
        <>
            <div
                id={id}
                className={`breadcrumb-item ${status()}`}
                key={`breadcrumb_${id}_${number}`}
                onClick={performClick}
                style={setStyle}
            >
                <div className='breadcrumb-content'>
                    <div className={`breadcrumb-bubble ${status()} ${theme}`}>{number}</div>
                    <div className={`text-content ${status()}`}>{children}</div>
                </div>
                {hasProgressed && number < currentNumber && <div className={`line ${theme}`}></div>}
            </div>
        </>
    );
};
